import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CmsPage from "@/pages/CmsPage";

// Cache module-level : on ne charge la carte des remplacements qu'une seule fois.
let _overridesPromise = null;
let _overridesCache = null;

function loadOverrides() {
  if (_overridesCache) return Promise.resolve(_overridesCache);
  if (!_overridesPromise) {
    _overridesPromise = api.get("/public/cms/route-overrides")
      .then(({ data }) => { _overridesCache = Array.isArray(data) ? data : []; return _overridesCache; })
      .catch(() => { _overridesCache = []; return _overridesCache; });
  }
  return _overridesPromise;
}

// Rend la page CMS si une page publiée remplace cette route, sinon la page d'origine.
export default function RouteOverride({ route, fallback }) {
  const [slug, setSlug] = useState(_overridesCache ? (_overridesCache.find((o) => o.route === route)?.slug || null) : undefined);

  useEffect(() => {
    let active = true;
    loadOverrides().then((list) => {
      if (!active) return;
      const match = (list || []).find((o) => o.route === route);
      setSlug(match ? match.slug : null);
    });
    return () => { active = false; };
  }, [route]);

  // Tant que la carte n'est pas chargée, on affiche la page d'origine (pas de flash blanc).
  if (slug === undefined) return fallback;
  if (slug) return <CmsPage slugProp={slug} />;
  return fallback;
}
